import PropTypes from "prop-types";
import React, { useContext, useEffect, useRef, useState } from "react";
import MUIFormControl from "@material-ui/core/FormControl";
import BuySellBtn from "assets/images/explore/buysellbtn.png";
import { tooltips } from "constants/tooltips";
import { InterpolateValue } from "../../../../../store/chartReducer";

import {
  map_coins,
  map_balance_to_coin,
  map_coin_to_name,
  map_category,
} from "store/constant";

import SecondChart from "views/dashboard/DashboardTakyon/SecondChart";
import ThirdChart from "views/dashboard/DashboardTakyon/ThirdChart";
import { weekly_portfolio } from "store/weekly";
import I from "immutable";
import useSocket from "hooks/useSocket";
import Transitions from "ui-component/extended/Transitions";
import { useDispatch, useSelector } from "react-redux";
import CoinContext from "contexts/CoinContext";
import { addExploreRecent } from "store/actions";
import colors from "assets/scss/_themes-vars.module.scss";
import ToolTipHelper from "ui-component/ToolTipHelper";

import {
  setLastTrade,
  TAB_ADD_PINNED_COIN,
  RESET_ALERT_TRENDING_BUY,
  RESET_ALERT_TRENDING_SELL,
  RESET_ALERT_SWL_POSITIVE,
  RESET_ALERT_SWL_NEGATIVE,
  RESET_ALERT_VEL_POSITIVE,
  RESET_ALERT_VEL_NEGATIVE,
} from "store/actions";

import {
  InputAdornment,
  OutlinedInput,
  InputLabel,
  IconButton,
  Chip,
  Fab,
} from "@material-ui/core";
import FavoriteButton from "../../components/FavoriteButton";

// material-ui
import { withStyles, makeStyles, useTheme } from "@material-ui/styles";

// material-ui
import {
  Badge,
  Button,
  Box,
  Paper,
  Checkbox,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Collapse,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableSortLabel,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { visuallyHidden } from "@material-ui/utils";

// third party
import PerfectScrollbar from "react-perfect-scrollbar";

// project imports
import MainCard from "ui-component/cards/MainCard";
import SubCard from "ui-component/cards/SubCard";

// assets
import Flag1 from "assets/images/widget/AUSTRALIA.jpg";
import Flag2 from "assets/images/widget/BRAZIL.jpg";
import Flag3 from "assets/images/widget/GERMANY.jpg";
import Flag4 from "assets/images/widget/UK.jpg";
import Flag5 from "assets/images/widget/USA.jpg";
const EOD = require("assets/json/EOD.json");

let mapEOD = I.Map();

EOD.forEach((item) => {

  const symbol = Object.keys(item)[0];
  const values = item[symbol];
  mapEOD = mapEOD.set( symbol, values);

});

// table filter
function descendingComparator(a, b, orderBy) {
    if (Number(b[orderBy]) < Number(a[orderBy])) {
      return -1;
    }
    if (Number(b[orderBy]) > Number(a[orderBy])) {
      return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  /*
  const sortedRows = [...stabilizedThis].sort(
    (a, b) => {

      const aVal = a[sortBy];

      const bVal = b[sortBy];

      if ( sortDirection === "asc") {
        return aVal > bVal ? 1 : -1;
      }

      return aVal < bVal ? 1 : -1;
    }
  );
  console.log(sortedRows);
  */
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const CustomizedBadge = withStyles((theme) => ({
  badge: {
    right: 0,
    top: -15,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}))(Badge);

// ===========================|| TABLE - HEADER ||=========================== //

// table header
const headCells = [
  {
    id: "time",
    numeric: false,
    disablePadding: true,
    label: "Time",
  },
  {
    id: "ltp",
    numeric: true,
    disablePadding: false,
    label: "LTP",
  },
  {
    id: "pred",
    numeric: true,
    disablePadding: false,
    label: "Predicted",
  },
  {
    id: "diff",
    numeric: true,
    disablePadding: false,
    label: "Spread",
  },
  {
    id: "diffpercent",
    numeric: true,
    disablePadding: false,
    label: "PnL-%",
  },
  {
    id: "position",
    numeric: true,
    disablePadding: false,
    label: "Pos",
  },
  {
    id: "buy",
    numeric: true,
    disablePadding: false,
    label: "Buy",
  },
  {
    id: "sell",
    numeric: true,
    disablePadding: false,
    label: "Sell",
  },
  {
    id: "pnl",
    numeric: true,
    disablePadding: false,
    label: "PnL",
  },
  {
    id: "sentiment",
    numeric: true,
    disablePadding: false,
    label: "Sent.",
  },
];

function EnhancedTableHead(props) {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
    purchaseAmount,
    changePurchaseAmount,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const theme = useTheme();
  const cornsilk =
    theme.palette.mode === "dark"
      ? colors.cornsilkLightTakyon
      : colors.cornsilkDarkTakyon;
  const whiteTakyon =
    theme.palette.mode === "dark"
      ? colors.whiteLightTakyon
      : colors.whiteDarkTakyon;

  return (
    <TableHead>
      <TableRow
        sx={{
          alignItems: "middle",
          align: "right",
          backgroundColor: "#191b1e",
        }}
      >
        {headCells.map((headCell) => (
          <TableCell
            sx={{
              backgroundColor: "#191b1e",
            }}
            key={headCell.id}
            align={headCell.numeric ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              // bgColor={"gray"}
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

// style constant
const useStyles = makeStyles({
  root: {
    width: "100%",
    overflow: "hidden",
  },
  sortSpan: visuallyHidden,
  cell: {
    cursor: "pointer",
  },
});

const Row = ({ row, trending_buy, trending_sell, pos, daily }) => {
  const [open, setOpen] = useState(false);
  const { coin, setCoin } = useContext(CoinContext);
  const dispatch = useDispatch();
  const theme = useTheme();
  const green =
    theme.palette.mode === "dark"
      ? colors.successLightTakyon
      : colors.successDarkTakyon;
  const red =
    theme.palette.mode === "dark"
      ? colors.errorLightTakyon
      : colors.errorDarkTakyon;
  const cornsilk =
    theme.palette.mode === "dark"
      ? colors.cornsilkLightTakyon
      : colors.cornsilkDarkTakyon;
  const whiteTakyon =
    theme.palette.mode === "dark"
      ? colors.whiteLightTakyon
      : colors.whiteDarkTakyon;

  const coin_style = map_coins.get(row.coin);
  // const coin_name = map_coin_to_name.get(row.wsname) ? map_coin_to_name.get(row.wsname) : row.wsname;

  // const coin_name = row.marketcap ?  row.marketcap.Name : row.coin;
  const coin_name = row.marketcap
    ? row.marketcap.Name
    : row.base_currency
    ? row.base_currency
    : row.base
    ? row.base
    : row.coin;

  const rung = row.ltp < row.avg ? red : green;
  const labelId = `${row.coin}`;
  const prung = (row.diff < 0) ? '#FF4444' : 'lightgreen';
  const ppercent = (row.diffpercent < 0) ? '#FF4444' : 'lightgreen';
  const sentiment_color = (row.diff < 0) ? 'lightred' : 'lightgreen';

  const handleListItemClick = (event, row) => {
    return dispatchTab(row);
  };

  const dispatchTab = (row) => {
    setCoin(row.wsname);
    setOpen(!open);

    
    /*
    dispatch({ type: TAB_ADD_PINNED_COIN, payload: { coin: row.coin } });
    dispatch(addExploreRecent(row.wsname));
    if (row.trending_buy && row.trending_buy.alerted) {
      dispatch({ type: RESET_ALERT_TRENDING_BUY, payload: { coin: coin } });
    } else if (row.trending_sell && row.trending_sell.alerted) {
      dispatch({ type: RESET_ALERT_TRENDING_SELL, payload: { coin: coin } });
    }
    */
  };

  const classes = useStyles();

  const alertTrendingBuyCount = trending_buy && trending_buy.alerted ? 1 : 0;
  const alertTrendingSellCount = trending_sell && trending_sell.alerted ? 1 : 0;

  return (
    <>
      {/******************************************************************************
                                           EXPLORE TABLE ROWS
                      ******************************************************************************/}
      <TableRow
        // sx={{ backgroundColor: "#191b1e" }}
        hover
        role="checkbox"
        key={row.coin}
        selected={row.coin === coin}
        // onClick={(event) => handleListItemClick(event, row)}
      >
        <TableCell onClick={(event) => handleListItemClick(event, row)}>
          <table
            style={{
              fixed: { "table-layout": "fixed" },
              td: { overflow: "hidden" },
            }}
          >
            <tr>
              <td style={{ textAlign: "left" }}>
                <font
                  variant="subtitle1"
                  style={{
                    fontSize: "1.1rem",
                    textAlign: "left",
                    color: cornsilk,
                  }}
                >
                  {row.timestamp}
                </font>
              </td>
            </tr>
          </table>
        </TableCell>

        <TableCell onClick={(event) => handleListItemClick(event, row)}>
          <table
            style={{
              fixed: { "table-layout": "fixed" },
              td: { overflow: "hidden" },
            }}
          >
            <tr>
              <td style={{ textAlign: "left" }}>
                <font
                  variant="subtitle1"
                  style={{
                    fontSize: "1.1rem",
                    textAlign: "left",
                    color: cornsilk,
                  }}
                >
                  {row.ltp}
                </font>
              </td>
            </tr>
          </table>
        </TableCell>

        <TableCell onClick={(event) => handleListItemClick(event, row)}>
          <table
            style={{
              fixed: { "table-layout": "fixed" },
              td: { overflow: "hidden" },
            }}
          >
            <tr>
              <td style={{ textAlign: "left" }}>
                <font
                  variant="subtitle1"
                  style={{
                    fontSize: "1.1rem",
                    textAlign: "left",
                    color: 'lightyellow',
                  }}
                >
                  {row.pred}
                </font>
              </td>
            </tr>
          </table>
        </TableCell>

        <TableCell onClick={(event) => handleListItemClick(event, row)}>
          <table
            style={{
              fixed: { "table-layout": "fixed" },
              td: { overflow: "hidden" },
            }}
          >
            <tr>
              <td style={{ textAlign: "left" }}>
                <font
                  variant="subtitle1"
                  style={{
                    fontSize: "1.1rem",
                    textAlign: "left",
                    color: prung,
                  }}
                >
                  {row.diff}
                </font>
              </td>
            </tr>
          </table>
        </TableCell>

        <TableCell onClick={(event) => handleListItemClick(event, row)}>
          <table
            style={{
              fixed: { "table-layout": "fixed" },
              td: { overflow: "hidden" },
            }}
          >
            <tr>
              <td style={{ textAlign: "left" }}>
                <font
                  variant="subtitle1"
                  style={{
                    fontSize: "1.1rem",
                    textAlign: "left",
                    color: ppercent,
                  }}
                >
                  {row.diffpercent}{'%'}
                </font>
              </td>
            </tr>
          </table>
        </TableCell>

        <TableCell
          sx={{ "font-weight": "bold", color: rung }}
          onClick={(event) => handleListItemClick(event, row)}
          className={classes.cell}
        >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "1.2rem",
                    textAlign: "left",
                    color: 'white',
                  }}
                >
                  {row.position}
                </Typography>
        </TableCell>

        <TableCell
          sx={{ "font-weight": "bold", color: rung }}
          onClick={(event) => handleListItemClick(event, row)}
          className={classes.cell}
        >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "1.2rem",
                    textAlign: "left",
                    color: 'lightgreen',
                  }}
                >
                  {'$'}{row.buy}
                </Typography>
        </TableCell>

        <TableCell sx={{ pl: 3 }} padding="checkbox">
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "1.2rem",
                    textAlign: "left",
                    color: '#FF4444',
                  }}
                >
                  {'$'}{row.sell}
                </Typography>
        </TableCell>


        <TableCell sx={{ pl: 3 }} padding="checkbox">
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "1.2rem",
                    textAlign: "left",
                    color: ppercent,
                  }}
                >
                  {'$'}{row.pnl}
                </Typography>
        </TableCell>

        <TableCell sx={{ pl: 3 }} padding="checkbox">
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "1.2rem",
                    textAlign: "left",
                    color: sentiment_color,
                  }}
                >
                  {row.sentiment}
                </Typography>
        </TableCell>

        {/*
        <TableCell sx={{ pl: 3 }} padding="checkbox">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-shopping-cart-plus" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <circle cx="6" cy="19" r="2" />
              <circle cx="17" cy="19" r="2" />
              <path d="M17 17h-11v-14h-2" />
              <path d="M6 5l6.005 .429m7.138 6.573l-.143 .998h-13" />
              <path d="M15 6h6m-3 -3v6" />
            </svg>
        </TableCell>
        */}
      </TableRow>
      {/******************************************************************************/}
      {/*                    COLLAPSIBLE DETAILS                                     */}
      {/******************************************************************************/}
    </>
  );
};
// =========================|| DASHBOARD ANALYTICS - LATEST CUSTOMERS TABLE CARD ||========================= //

const TableCard = ({ title, coin_name, rows }) => {
  const [checkbox, setCheckbox] = React.useState([
    true,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [category, setCategory] = React.useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("percent_since_day_close");
  const [query, setQuery] = useState("");

  const [tableHeight, setTableHeight] = useState(
        window.innerHeight - 860
  );

    React.useEffect(() => {
        const onResize = () => {
            setTableHeight(window.innerHeight - 860);
        };

        window.addEventListener("resize", onResize);

        return () => window.removeEventListener("resize", onResize);
    }, []);

  const classes = useStyles();
  const { emit } = useSocket();
  const { coin, setCoin } = useContext(CoinContext);
  const dispatch = useDispatch();
  const theme = useTheme();
  const green =
    theme.palette.mode === "dark"
      ? colors.successLightTakyon
      : colors.successDarkTakyon;
  const red =
    theme.palette.mode === "dark"
      ? colors.errorLightTakyon
      : colors.errorDarkTakyon;
  const cornsilk =
    theme.palette.mode === "dark"
      ? colors.cornsilkLightTakyon
      : colors.cornsilkDarkTakyon;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  let items = [];
  let categoryItems = [];
  const start = Date.now();
  let filteredItems = [];
  if (rows !== undefined) {
    rows
      .filter((post) => {
        if (query === "") {
          return post;
        } else if (post.coin_name.toLowerCase().includes(query.toLowerCase())) {
          return post;
        }
      })
      .map((post, index) => {
        filteredItems.push(post);
      });
  }

  let changed = items.length;

  if (filteredItems !== undefined) {
    if (checkbox[0]) {
      filteredItems
        .filter((post) => {
          return post;
        })
        .map((post, index) => {
          items.push(post);
        });
    } else if (checkbox[1]) {
      filteredItems
        .filter((post) => {
          if (post && post.invested < 0.1) {
            return post;
          }
        })
        .map((post, index) => {
          items.push(post);
        });
    } else if (checkbox[4]) {
      /**
            else if ( checkbox[2])
            {
                filteredItems.filter((post) => {
                    if (post && post.trending_sell !== undefined)
                    {
                        return post;
                    }
                }).map((post, index) => {
                    items.push(post);
                });
            }
            else if ( checkbox[3])
            {
                filteredItems.filter((post) => {
                    if (post && post.trending_buy !== undefined)
                    {
                        return post;
                    }
                }).map((post, index) => {
                    items.push(post);
                });
            }
            *
            */
      filteredItems
        .filter((post) => {
          if (post) {
            if (post.trending_buy && post.trending_buy.alerted) {
              return post;
            }
            if (post.trending_sell && post.trending_sell.alerted) {
              return post;
            }
          }
        })
        .map((post, index) => {
          items.push(post);
        });
    } else if (checkbox[5]) {
      filteredItems
        .filter((post) => {
          if (post && post.invested > 0.1) {
            return post;
          }
        })
        .map((post, index) => {
          items.push(post);
        });
    } else {
      items = filteredItems;
    }
  }

  if (items !== undefined) {
    if (category[0]) {
      items
        .filter((post) => {
          if (
            map_category.get(post.wsname) &&
            map_category.get(post.wsname) === "defi"
          ) {
            return post;
          }
        })
        .map((post, index) => {
          categoryItems.push(post);
        });
    } else if (category[1]) {
      items
        .filter((post) => {
          if (
            map_category.get(post.wsname) &&
            map_category.get(post.wsname) === "gamefi"
          ) {
            return post;
          }
        })
        .map((post, index) => {
          categoryItems.push(post);
        });
    } else if (category[2]) {
      items
        .filter((post) => {
          if (
            map_category.get(post.wsname) &&
            map_category.get(post.wsname) === "lending"
          ) {
            return post;
          }
        })
        .map((post, index) => {
          categoryItems.push(post);
        });
    } else if (category[3]) {
      items
        .filter((post) => {
          if (
            map_category.get(post.wsname) &&
            map_category.get(post.wsname) === "memes"
          ) {
            return post;
          }
        })
        .map((post, index) => {
          categoryItems.push(post);
        });
    } else if (category[4]) {
      items
        .filter((post) => {
          if (!map_category.get(post.wsname)) {
            return post;
          }
        })
        .map((post, index) => {
          categoryItems.push(post);
        });
    } else {
      items
        .filter((post) => {
          return post;
        })
        .map((post, index) => {
          categoryItems.push(post);
        });
    }
  }

  const handleCheckboxSelect = (event, index) => {
    console.log("handleCheckboxSelect: " + index);
    console.log(event.target.checked);
    if (event.target.checked) {
      let cb = [false, false, false, false, false];
      cb[index] = true;
      setCheckbox(cb);
    } else {
      let cb = [false, false, false, false, false];
      setCheckbox(cb);
    }
  };

  const handleCategorySelect = (event, index) => {
    console.log("handleCheckboxSelect: " + index);
    console.log(event.target.checked);
    if (event.target.checked) {
      let cb = [false, false, false, false, false];
      cb[index] = true;
      setCategory(cb);
    } else {
      let cb = [false, false, false, false, false];
      setCategory(cb);
    }
  };

  const [firstInit, setFirstInit] = useState(false);

  useEffect(() => {
    const item = window.localStorage.getItem("explore_card_help");
    if (!item) {
      setFirstInit(true);
    }
  }, []);

    categoryItems.map((row, index) => {
        let day_close_diff = 0.0;
        let percent_since_day_close = 0.0;
        row.day_close_diff = (row.ltp - row.day_close).toFixed(2);
        if ( row.ltp !== undefined && row.day_close !== undefined)
        {
            row.percent_since_day_close = ((row.ltp - row.day_close) * 100 / row.day_close).toFixed(2);
        } else {
            row.percent_since_day_close = 0;
        }

        if ( row.ltp !== undefined && row.day_close !== undefined)
        {
            row.day_2_diff = ((row.ltp - row.day_2_high)).toFixed(2);
            row.day_2_percent = (row.day_2_diff * 100.0 / row.day_2_high).toFixed(2);
        } else {
            row.day_2_diff = 0;
            row.day_2_percent = 0;
        }
    });
  //


  if (rows === undefined)
  {
       const row = {
        'time': new Date(),
        'timestamp': new Date().toLocaleString(),
        'ltp': 0,
        'pred': 0,
        'diff': 0,
        'diffpercent': 0,
        'position': 0,
        'buy': 0,
        'sell': 0,
        'pnl': 0,
    };
    rows = [row];
  }
  const buy = rows[0].buy;
  const sell = rows[rows.length-1].sell;
  const srung = ((sell-buy) > 0) ? 'lightgreen': '#F44';
  const key_style = map_coins.get(coin_name);

  return (
    <>
      {/* <ExplorePortfolio /> */}
      <Grid container padding={1.0} />
      <SubCard content={false} sx={{ align: "center" }}>
        <Grid container padding={0} spacing={0} alignItems="center">
          <Grid item xs={12} lg={3.0}>
            <MUIFormControl>
              <InputLabel>Search</InputLabel>
              <OutlinedInput
                fullWidth
                label="Search"
                name={"search"}
                onChange={(event) => setQuery(event.target.value)}
              />
            </MUIFormControl>
          </Grid>
          <Grid item xs={12} lg={8.5}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "1.0rem",
                    textAlign: "center",
                    color: 'white',
                  }}
                >
                  <font sx={{ "font-size": "1.0rem" }} class={key_style} >{coin_name}</font>
                  {'  AI Quant Robo Advisor --> '}
                  <font style={{'font-size': '1.0rem'}}>{'BUY: $ '}</font>
                  <font style={{'font-size': '1.1rem', 'color': 'lightgreen'}}>{buy}</font>
                  <font style={{'font-size': '1.1rem'}}>{', SELL: $ '}</font>
                  <font style={{'font-size': '1.0rem', 'color': '#F44'}}>{sell}</font>
                  {', PnL: $ '}<font style={{'color': srung}}>{(sell - buy).toFixed(2)}</font>
                  {', PnL%: '}<font style={{'color': srung}}>{((sell - buy)*100/buy).toFixed(2)}</font>{' %     '}
                </Typography>
          </Grid>
        </Grid>
        <TableContainer
            component={Paper}
            sx={{
                resize: 'vertical',
                height: 400, // "calc(100vh - 800px)",
                overflow: "auto",
            }}
        >
          <Table stickyHeader size="small" aria-label="explore">
            <EnhancedTableHead
              // classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              // backgroundColor={"#ccc"}
            />
            <TableBody>
              {stableSort(categoryItems, getComparator(order, orderBy)).map(
                (row, index) => {
                  const coin_style = map_coins.get(row.coin);
                  const coin_name = map_coin_to_name.get(row.wsname)
                    ? map_coin_to_name.get(row.wsname)
                    : row.wsname;
                  const rung = row.ltp < row.avg ? red : green;
                  const labelId = `${row.coin}`;
                  // let invested = (row.position) ? (row.position.balance * row.position.market_price) : 0;
                  // let quantity = (row.position) ? (row.position.balance) : 0;
                  let qty_coin = map_balance_to_coin.get(row.coin)
                    ? map_balance_to_coin.get(row.coin)
                    : row.coin;
                  let dollar = "$";
                  if (row.invested === 0 || isNaN(row.invested)) {
                    row.invested = " ";
                    dollar = " ";
                    row.quantity = " ";
                    qty_coin = " ";
                  }

                  const trending_buy = row.trending_buy ? row.trending_buy : {};
                  const trending_sell = row.trending_sell
                    ? row.trending_sell
                    : {};
                  const pos = row.position ? row.position : {};
                  const daily = row.daily ? row.daily : {};

                  return (
                    <Row
                      row={row}
                      trending_buy={trending_buy}
                      trending_sell={trending_sell}
                      pos={pos}
                      daily={daily}
                    />
                  );
                }
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </SubCard>
    </>
  );
};

TableCard.propTypes = {
  title: PropTypes.string,
};

export default TableCard;
